// extracted by mini-css-extract-plugin
module.exports = {"header":"_7a3fb80146--header--HDJXF","slider":"_7a3fb80146--slider--Nv4oA"};